import React, { useEffect, useState } from 'react';
import { Phone } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-charcoal/95 backdrop-blur-md shadow-lg py-3' : 'bg-transparent py-5'}`} data-id="element-93">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between" data-id="element-94">
        {/* Logo */}
        <a href="#inicio" className="flex items-center" data-id="element-95">
          <img src="https://cdn.magicpatterns.com/uploads/7iH6zyTr3rcaNUzsDXXd7i/Exclusive_agent_leads_logo_(1000_x_500_px)_2.png" alt="Xclusive Agent Leads Logo" className="h-10 w-auto object-contain" decoding="async" data-id="element-96" />
        </a>

        {/* CTA Button */}
        <a href="https://calendly.com/josephgh19/45min" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-brand-orange hover:bg-orange-500 text-white px-5 py-2.5 rounded-lg font-bold transition-all shadow-lg shadow-brand-orange/20 hover:shadow-brand-orange/40" data-id="element-97">
          <Phone className="w-4 h-4" data-id="element-98" />
          <span data-id="element-99">Agendar una llamada</span>
        </a>
      </div>
    </header>;
}